import { Body, styled } from '@teko/ds-desktop';
import { CheckOutlined } from '@teko/ds-icon';
import { SizeEnum } from '@teko/types/ds';
import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_ICON_ACTIVE_SIZE = {
  [SizeEnum.xs]: 11,
  [SizeEnum.s]: 14
};
const SelectionOption = (_a) => {
  var _b = _a, {
    children,
    block = true,
    isActive = false,
    onClick,
    iconActiveSize = SizeEnum.m,
    disabled = false,
    activeIconPosition = "top-right"
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "isActive",
    "onClick",
    "iconActiveSize",
    "disabled",
    "activeIconPosition"
  ]);
  const handleClick = () => {
    if (!disabled && typeof onClick === "function") {
      onClick(!isActive);
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    isActive,
    disabled,
    block,
    onClick: handleClick
  }, rest), typeof children === "string" ? /* @__PURE__ */ React.createElement(Body, {
    style: { textAlign: "center" },
    level: 1
  }, children) : children, !disabled && isActive && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ActiveBorder, {
    iconActiveSize,
    activeIconPosition
  }), /* @__PURE__ */ React.createElement(Checked, {
    iconActiveSize,
    activeIconPosition
  }, /* @__PURE__ */ React.createElement(CheckOutlined, {
    size: MAPPING_ICON_ACTIVE_SIZE[iconActiveSize] || 20,
    color: "#ffffff"
  }))));
};
const getBorderColor = (props) => {
  return props.theme && props.isActive ? props.theme.colors.primary500 : "#e0e0e0";
};
const Wrapper = styled.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: #fff;
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  ${props.disabled ? `
    & > * {
      opacity: 0.4 !important;
    }
  ` : ""}
  &:hover {
    background: ${props.isActive || props.disabled ? "" : "#f3f3f3"} ;
  }
`);
const ActiveBorder = styled.div(({ iconActiveSize, theme, activeIconPosition }) => {
  const size = iconActiveSize === SizeEnum.xs || iconActiveSize === SizeEnum.s ? 24 : 36;
  const color = theme == null ? void 0 : theme.colors.primary500;
  if (activeIconPosition === "bottom-right") {
    return `
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 ${size}px ${size}px;
        border-color: transparent transparent ${color} transparent;
      `;
  }
  return `
      position: absolute;
      top: -1px;
      right: -1px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 ${size}px ${size}px 0;
      border-color: transparent ${color} transparent transparent;
    `;
});
const Checked = styled.span(({ iconActiveSize, activeIconPosition }) => `
  display: flex;
  position: absolute;
  right: ${iconActiveSize === SizeEnum.xs ? "2px;" : "-1px;"}
  ${activeIconPosition === "bottom-right" ? `bottom: ${iconActiveSize === SizeEnum.xs ? "1px;" : "-1px;"}` : `top: ${iconActiveSize === SizeEnum.xs ? "1px;" : "-1px;"}`}
  z-index: 0;
`);

export { SelectionOption };
